export const convertToTimeSpanFormat = (time: string, format: "HH:mm" | "HH:mm:ss"): string => {
  let hours = 0,
    minutes = 0,
    seconds = 0;

  if (format === 'HH:mm') {
    [hours, minutes] = time.split(':').map(Number);
  } else if (format === 'HH:mm:ss') {
    [hours, minutes, seconds] = time.split(':').map(Number);
  } else {
    throw new Error(`Unsupported format: ${format}`);
  }

  let result = 'PT';
  if (hours > 0) result += `${hours}H`;
  if (minutes > 0) result += `${minutes}M`;
  if (seconds > 0) result += `${seconds}S`;

  if (result === 'PT') result = 'PT0S';

  return result;
};
